
// playground requires you to assign document definition to a variable called dd
export const dailyProductReport = ({ invoiceData, firm,date}) => {
    var dd = {
        pageOrientation: 'landscape',
        content: [
            { text: 'Daily Product Book\n\n', style: "gstDataBold" },
			{
				table: {
					widths: ['*'],
					body: [			
						[
							{
								text:[]
								}
                        ],
                        [
							{ text: '', style: "gstDataBold1" },
						],
					]
				}
			},
            {
                table: {

                    body: [
                        [
                            { text: 'Invoice ID', style: "gstHeader" },
                            { text: 'Firm', style: "gstHeader1" },
                            { text: 'Customer Name', style: "gstHeader"},
                            { text: 'Product Name', style: "gstHeader"},
                            { text: 'Opening Quantity', style: "gstHeader"},
                            { text: 'Purchase Quantity', style: "gstHeader"},
                            { text: 'Sale Quantity', style: "gstHeader"},
                            { text: 'Amount', style: "gstHeader"},
                            { text: 'Closing Quantity', style: "gstHeader"},
                        ],

                    ]
                }

            },

        ],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d',
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    }
    dd.content[1].table.body[0][0].text.push({ text: '   Firm : '+ (firm || ""), bold: true })
    if (date) {
        dd.content[1].table.body[0][0].text.push({ text: '   Date : '+ date, bold: true })
    }
    invoiceData.map((invoice) => {
            dd.content[2].table.body.push(
                [
                    { text: invoice[0] ,style: "gstData" },
                    { text: invoice[1], style: "gstData" },
                    { text: invoice[2], style: "gstData" },
                    { text: invoice[3], style: "gstData" },
                    { text: invoice[4], style: "gstData" },
                    { text: invoice[5], style: "gstData" },
                    { text: invoice[6], style: "gstData" },
                    { text: invoice[7], style: "gstData" },
                    { text: invoice[8], style: "gstData" },
    
                ]
            )
    })


    return dd;
}


export const dailyProductGroupReport = ({ invoiceData, firm,date,isDetailed}) => {
    var dd = {
        pageOrientation: 'landscape',
        content: [
            { text: 'Daily Product-Group Book\n\n', style: "gstDataBold" },
			{
				table: {
					widths: ['*'],
					body: [			
						[
							{
								text:[]
								}
                        ],
                        [
							{ text: '', style: "gstDataBold1" },
						],
					]
				}
			},
            {
                table: {

                    body: [
                        [
                            { text: 'Group Name', style: "gstHeader" },
                            { text: 'Opening Quantity', style: "gstHeader1" },
                            { text: 'Purchase Quantity', style: "gstHeader"},
                            { text: 'Purchase Amount', style: "gstHeader"},
                            { text: 'Sale Quantity', style: "gstHeader"},
                            { text: 'Sale Amount', style: "gstHeader"},
                            { text: 'Closing Quantity', style: "gstHeader"},
                        ],

                    ]
                }

            },

        ],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstCombineHeader: {
                fontSize: 9,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstCombinedData: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                fillColor: '#15155d',
                color: '#FFFFFF'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d',
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    }
    dd.content[1].table.body[0][0].text.push({ text: '   Firm : '+ (firm || ""), bold: true })
    if (date) {
        dd.content[1].table.body[0][0].text.push({ text: '   Date : '+ date, bold: true })
    }
    let count = 0;
    invoiceData.map((invoice) => {
        if(invoice[0] && !invoice[0].includes("Combined Product") && invoice[0] != "") {
            if(invoice.length == '7') {
                count = 0;
                dd.content[2].table.body.push(
                    [
                        { text: invoice[0] ,style: "gstCombinedData" },
                        { text: invoice[1], style: "gstCombinedData" },
                        { text: invoice[2], style: "gstCombinedData" },
                        { text: invoice[3], style: "gstCombinedData" },
                        { text: invoice[4], style: "gstCombinedData" },
                        { text: invoice[5], style: "gstCombinedData" },
                        { text: invoice[6], style: "gstCombinedData" },
                    ]
                )
            } else if(invoice.length == '9'  && isDetailed) {
                count++;
                if(count == 1) {
                    dd.content[2].table.body.push(
                        [
                            { table: {
        
                                body: [
                                    [
                                        { text: 'Invoice Id', style: "gstHeader" },
                                        { text: 'Firm', style: "gstHeader1" },
                                        { text: 'Customer Name', style: "gstHeader"},
                                        { text: 'Product Name', style: "gstHeader"},
                                        { text: 'Opening QTY', style: "gstHeader"},
                                        { text: 'Purchase QTY', style: "gstHeader"},
                                        { text: 'Sale QTY', style: "gstHeader"},
                                        { text: 'Amount', style: "gstHeader"},
                                        { text: 'Closing QTY', style: "gstHeader"},
                                    ],
                                    [
                                        { text: invoice[0], style: "gstData" },
                                        { text: invoice[1], style: "gstData" },
                                        { text: invoice[2], style: "gstData"},
                                        { text: invoice[3], style: "gstData"},
                                        { text: invoice[4], style: "gstData"},
                                        { text: invoice[5], style: "gstData"},
                                        { text: invoice[6], style: "gstData"},
                                        { text: invoice[7], style: "gstData"},
                                        { text: invoice[8], style: "gstData"},
                                    ],
            
                                ]
                            } ,style: "gstData" ,colSpan: 7},
                        
                        ]
                    )
                } else {
                    dd.content[2].table.body[dd.content[2].table.body.length-1][0].table.body.push(
                        [
                            { text: invoice[0], style: "gstData" },
                            { text: invoice[1], style: "gstData" },
                            { text: invoice[2], style: "gstData"},
                            { text: invoice[3], style: "gstData"},
                            { text: invoice[4], style: "gstData"},
                            { text: invoice[5], style: "gstData"},
                            { text: invoice[6], style: "gstData"},
                            { text: invoice[7], style: "gstData"},
                            { text: invoice[8], style: "gstData"},
                        ]
                    )
                }
            } else if(isDetailed) {
                count++;
                if(count == 1) {
                    dd.content[2].table.body.push(
                        [
                            { table: {
        
                                body: [
                                    [
                                        { text: 'Product Name', style: "gstCombineHeader" },
                                        { text: 'Sale Quantity', style: "gstCombineHeader" },
                                        { text: 'Sale Amount', style: "gstCombineHeader"},
                                    ],
                                    [
                                        { text: invoice[0], style: "gstData" },
                                        { text: invoice[1], style: "gstData" },
                                        { text: invoice[2], style: "gstData"},
                                    ],
            
                                ]
                            } ,style: "gstData" ,colSpan: 7},
                        
                        ]
                    )
                } else {
                    dd.content[2].table.body[dd.content[2].table.body.length-1][0].table.body.push(
                        [
                            { text: invoice[0], style: "gstData" },
                            { text: invoice[1], style: "gstData" },
                            { text: invoice[2], style: "gstData"}
                        ]
                    )
                }
            }
           
        }
    })


    return dd;
}






// WEBPACK FOOTER //
// ./src/utils/pdf-reports/dailyProductReport.js